import { TextField } from '@mui/material';
import { getExtensionDuration } from 'app/helpers/getExtensionDuration';
import moment from 'moment';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface NumberOfWeeksProps {
  readOnly?: boolean;
}

export const NumberOfWeeks = ({ readOnly }: NumberOfWeeksProps) => {
  const { control, setValue, getValues } = useFormContext();
  const { t } = useTranslation();

  const startDate = moment(useWatch({ name: 'startDate' }) ?? null);
  const endDate = moment(useWatch({ name: 'endDate' }) ?? null);

  useEffect(() => {
    const weeks = getExtensionDuration(startDate, endDate);
    if (!isNaN(weeks)) {
      setValue('numberOfWeeks', weeks);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <Controller
      control={control}
      name={'numberOfWeeks'}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          fullWidth
          id="numberOfWeeks"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.numberOfWeeks')}
          InputProps={{
            readOnly: readOnly !== undefined ? readOnly : true,
            style: {
              pointerEvents: readOnly !== undefined ? (readOnly ? 'none' : 'auto') : 'none',
            },
          }}
          value={getValues('numberOfWeeks') ?? ''}
          {...rest}
        />
      )}
    />
  );
};
